import React, { memo } from "react";

import { useSelector } from "react-redux";

import { SaleType } from "constants/sale";

import { getCurrentSale } from "selectors";

import { useIsFullScreenWithRouteCheck } from "hooks";

import ScaleOperatorTabs from "./BobbyCalfSaleTabs";
import ClearingSaleTabs from "./ClearingSaleTabs";
import LivestockSaleTabs from "./LivestockSaleTabs";
import PrivateSaleTabs from "./PrivateSaleTabs";
import ReferenceSaleTabs from "./ReferenceSaleTabs";
import SundrySaleTabs from "./SundrySaleTabs";

function SaleTabsComponent() {
  const { sale_type: saleType } = useSelector(getCurrentSale);

  const isFullScreen = useIsFullScreenWithRouteCheck();

  if (isFullScreen) {
    return null;
  }

  switch (saleType) {
    case SaleType.CLEARING:
      return <ClearingSaleTabs />;
    case SaleType.BOBBYCALF:
      return <ScaleOperatorTabs />;
    case SaleType.OVER_HOOKS:
      return <PrivateSaleTabs />;
    case SaleType.PADDOCK:
      return <PrivateSaleTabs />;
    case SaleType.SUNDRY_SALE:
      return <SundrySaleTabs />;
    case SaleType.REFERENCE_SALE:
      return <ReferenceSaleTabs />;
    default:
      return <LivestockSaleTabs />;
  }
}

export default memo(SaleTabsComponent);
